import {Field, useFormikContext} from 'formik';
import React, {FC} from 'react';
import Label from '../label/label';
import {validateItemName} from '../../utilities/Validation';
import EntityHierarchy from '../entityHierarchy/entityHierarchy';
import {TranslationKeys} from '../../contexts/TranslationKeys';
import {useLocale} from '../../contexts/localeContext';
import Togglebox from '../togglebox/togglebox';
import {getProfileSubTypeFromBioMake} from "../../utilities/BioUtils";
import PaginatedSearchableSelectField from "../selection-field/paginated-searchable-select-field";
import {
    getBiometricDevicePreset,
} from "../../services/hardwarePresetService";
import {Name} from "../../models/Name";

const BiometricCard: FC = () => {
    const { errors, values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();

    const getBioPresets = async (listQuery, make) => {
        const deviceProfileSubType = getProfileSubTypeFromBioMake(make ?? '')
        const presets = await getBiometricDevicePreset(listQuery, deviceProfileSubType)
        return {
            rows: presets.rows.map(r => ({label: r.name, value: r.id.toString()})) as Name[],
            pagination: presets.pagination
        }
    }

    return <>
        <div className="w-full p-2 inline-flex justify-start items-center bg-white">

                {values.id
                    ? <div className="flex flex-col py-4 px-4 card-details">
                        <EntityHierarchy title={values.name} tree={{ label: values.site ? values.site : translate.byKey(TranslationKeys.system), node: { label: values.name } }} />
                    </div>
                    : null}
            {/* </div> */}
            <div className="flex flex-col py-4 px-8">
                <div className="mb-1">
                    <div className="flex flex-row justify-between">
                        <Label
                            htmlFor="name"
                            className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.name)}:</Label>
                        {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                    </div>
                    <Field
                        type="text"
                        name="name"
                        autoFocus
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                        validate={(value) => validateItemName(value, translate)} />
                </div>

                <div className="mb-1">
                    <div className="flex flex-row justify-between">
                        <Label
                            htmlFor="serialAddress"
                            className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.serialAddress)}:</Label>
                    </div>
                    <Field
                        name="serialAddress"
                        disabled={true}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                </div>
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="address"
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.address)}:</Label>
                </div>
                <Field
                    name="address"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
            </div>
            <div className="flex flex-col px-8 mb-12">
                <Label
                    htmlFor="biometricProfileSelectField"
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.preset)}:</Label>

                <PaginatedSearchableSelectField
                    onSelect={(event, value?) => { setFieldValue('preset', value?.label); setFieldValue('presetId', value?.value) }}
                    name={translate.byKey(TranslationKeys.preset)}
                    searchAccessor={'trnName'}
                    dataMethod={(listQuery) => getBioPresets(listQuery, values.biometricMake ?? '')}
                    key={'biometricProfileSelectField'}
                    accessor={"presetId"}
                    selectedItemLabel={values.preset} />
                <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="enabled"
                        className="text-xs text-gray-600 mt-1 my-1">{translate.byKey(TranslationKeys.enabled)}:</Label>
                </div>
                <div className="my-0">
                    <Togglebox name="enabled" label="" />
                </div>
            </div>
        </div>
    </>;
};

export default BiometricCard;
